import { useFormat } from 'helpers/hooks/useFormat';
import useGetUserInfo from 'helpers/hooks/useGetUserInfo';
import { useParams } from 'next/navigation';
import React, { useCallback, useEffect, useState } from 'react';
import { ProjectConfig } from 'types/project-config';

interface SidebarFooterProps {
  projectConfig?: ProjectConfig;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({ projectConfig }) => {
  const { locale } = useParams();
  const { formatMessage: formatMessagePadi } = useFormat({ name: 'padi' });
  const padiBlueLink = 'text-padi-blue hover:text-padi-blue-darker';
  const padiDomains = projectConfig?.padiDomains;
  const { idToken, checkUserActiveClubMember } = useGetUserInfo();
  const [isClubMember, setIsClubMember] = useState(false);

  const fetClubStatus = useCallback(async () => {
    const isActiveClubMember = await checkUserActiveClubMember();
    setIsClubMember(isActiveClubMember);
  }, [checkUserActiveClubMember, isClubMember]);
  useEffect(() => {
    if (idToken) {
      fetClubStatus();
    }
  }, [idToken, fetClubStatus]);

  return (
    <div data-id="sidebar-footer">
      <div data-id="padi-club-section" className="pb-20">
        <h3 data-id="padi-club-heading" className="mb-10 text-base font-bold">
          {formatMessagePadi({
            id: 'padiClub',
            defaultMessage: 'PADI Club',
          })}
        </h3>
        <ul data-id="padi-club-list" role="list" className="space-y-4 text-sm text-gray-900">
          {(!idToken || isClubMember) && (
            <li data-id="padi-club-exclusive-item" className="pb-5">
              <a
                data-id="padi-club-exclusive-link"
                href={`/${locale}/product-definition/promotion/promotion-club-free-ecard/`}
                className="hover:text-padi-gray-darker"
              >
                {formatMessagePadi({
                  id: 'padi.club.exclusive',
                  defaultMessage: 'PADI Club Exclusive',
                })}
              </a>
            </li>
          )}
          <li data-id="padi-club-learn-item" className="pb-5">
            <a data-id="padi-club-learn-link" href={`/${locale}/padi-club/`} className={padiBlueLink}>
              {formatMessagePadi({
                id: 'learnAboutPadiClub',
                defaultMessage: 'Learn about PADI Club',
              })}
            </a>
          </li>
          <li data-id="certification-cards-item" className="pb-5">
            <a
              data-id="certification-cards-link"
              href={`${padiDomains?.learning}/certifications`}
              className={padiBlueLink}
            >
              {formatMessagePadi({
                id: 'viewCertificationCards',
                defaultMessage: 'View your existing certification cards',
              })}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SidebarFooter;
